import type { FileRecordVersion } from "@cohesive/api-client";
import type { MediaIntent } from "@cohesive/ui-components";

/**
 * Mirrors {@link pickFileRecordMediaURL} for a `FileRecordVersion` row.
 * Uses parent `FileRecord.content_type` for thumbnail vs full behavior.
 */
export function pickFileRecordVersionMediaURL(
  version: Pick<FileRecordVersion, "url" | "download_url" | "preview_urls">,
  intent: MediaIntent,
  contentType: string,
  { previewSize = "640" }: { previewSize?: string } = {},
): string | undefined {
  if (intent === "full") {
    return (
      version.url ?? version.preview_urls?.[previewSize] ?? version.download_url
    );
  }

  const ct = contentType ?? "";
  const directlyDisplayable =
    ct.startsWith("image/") || ct.startsWith("video/");

  if (!directlyDisplayable) {
    return version.preview_urls?.[previewSize];
  }
  return version.preview_urls?.[previewSize] ?? version.url;
}
